var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCallEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "call_end"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1263_6125",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1263_6125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "call_end_2",
    d: "M12.0003 8C13.967 8 15.9045 8.39583 17.8128 9.1875C19.7211 9.97917 21.417 11.1667 22.9003 12.75C23.1003 12.95 23.2003 13.1833 23.2003 13.45C23.2003 13.7167 23.1003 13.95 22.9003 14.15L20.6003 16.4C20.417 16.5833 20.2045 16.6833 19.9628 16.7C19.7211 16.7167 19.5003 16.65 19.3003 16.5L16.4003 14.3C16.267 14.2 16.167 14.0833 16.1003 13.95C16.0336 13.8167 16.0003 13.6667 16.0003 13.5V10.65C15.367 10.45 14.717 10.2917 14.0503 10.175C13.3836 10.0583 12.7003 10 12.0003 10C11.3003 10 10.617 10.0583 9.95029 10.175C9.28363 10.2917 8.63363 10.45 8.00029 10.65V13.5C8.00029 13.6667 7.96696 13.8167 7.90029 13.95C7.83363 14.0833 7.73363 14.2 7.60029 14.3L4.70029 16.5C4.50029 16.65 4.27946 16.7167 4.03779 16.7C3.79613 16.6833 3.58363 16.5833 3.40029 16.4L1.10029 14.15C0.900293 13.95 0.800293 13.7167 0.800293 13.45C0.800293 13.1833 0.900293 12.95 1.10029 12.75C2.56696 11.1667 4.25863 9.97917 6.17529 9.1875C8.09196 8.39583 10.0336 8 12.0003 8Z",
    fill: "#F8153B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCallEnd);
export default __webpack_public_path__ + "static/media/red-call-end.93be6b7ccac72d92a9b0edb1cd1a5ed3.svg";
export { ForwardRef as ReactComponent };